export default __webpack_public_path__ + "static/media/gasag_l2.4888de55.png";